// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__hyn2G","hoverable":"Icon_hoverable__Iz4NB","isLoader":"Icon_isLoader__+O+lt","click":"Icon_click__2dcOt"};